import React from "react";
import Exploration from "../Exploration";
import { useTranslationContext } from "@providers/TranslationProvider";
import { usePageContext } from "@providers/PageProvider";
import { sustainabilityPage } from "@utils/helper";

export default function SustainableExploration() {
  const { i18n } = useTranslationContext();
  const { pageData } = usePageContext();
  const articles = sustainabilityPage.formatArticles(pageData);
  return (
    <div data-scroll-section style={{ paddingTop: "6.875rem" }}>
      <Exploration
        heading={i18n.t("About.sustainable.blogs.heading")}
        items={articles}
      />
    </div>
  );
}
